export default __webpack_public_path__ + "static/media/NewOrganDataLogo.36f73d2d.svg";